module.exports = __webpack_public_path__ + "img/invoice-ok.997809bd.svg";